module.exports = __webpack_public_path__ + "assets/img/d358-ve.svg";